import { render, staticRenderFns } from "./NumberIndex.vue?vue&type=template&id=19a401e5&scoped=true&"
import script from "./NumberIndex.vue?vue&type=script&lang=js&"
export * from "./NumberIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a401e5",
  null
  
)

export default component.exports